/**
 * Admin API base URL strategy:
 * - Development: always use relative paths for Vite proxy + same-origin cookies.
 * - Non-development: use explicit configured base URL when provided.
 */

function trimTrailingSlashes(value: string): string {
  return value.replace(/\/+$/, '')
}

export function resolveApiBaseUrl(): string {
  if (import.meta.env.DEV) {
    return ''
  }

  const configuredBase = (import.meta.env.VITE_API_BASE_URL || '').trim()
  return configuredBase ? trimTrailingSlashes(configuredBase) : ''
}

export default resolveApiBaseUrl
